import React from 'react';

const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96px"
      height="96px"
      viewBox="0 0 96 96"
      version="1.1"
    >
      <g
        id="icon-overview-1--96x96"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <circle id="Oval" cx="48" cy="48" r="48" />
        <path
          d="M29.375,62.2058824 L67.625,62.2058824 M37.75,47.5 L76,47.5 M22,32.7941176 L60.25,32.7941176"
          id="Combined-Shape"
          stroke="#F2F5F8"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
};

export default MenuIcon;
